// extracted by mini-css-extract-plugin
export var settingsList = "_3e-0";
export var settingsRow = "_3e-1";
export var warningDot = "_3e-2";